import { NgModule } from '@angular/core';
import { RenderBlocksModule } from 'render/render-blocks/render-blocks.module';
import { AltTextPipe } from 'render/render-shared/alt-text/alt-text.pipe';
import { RenderSharedModule } from 'render/render-shared/render-shared.module';
import { RenderProductColorsModule } from 'render/render-shared/ui/render-product-colors/render-product-colors.module';
import { RenderProductPricesModule } from 'render/render-shared/ui/render-product-prices/render-product-prices.module';
import { RenderProductPurchaseOptionsModule } from 'render/render-shared/ui/render-product-sizes/render-product-purchase-options.module';
import { RenderVideoModule } from 'render/render-shared/ui/render-video/render-video.module';
import { LazyLoadModule } from 'shared/lazy-load/lazy-load.module';
import { SharedModule } from 'shared/shared.module';

import { ApiHudsonService } from 'extensions/st/piece-hudson/front/services/api-hudson.service';
import { EmplifiHudsonTransformerService } from 'extensions/st/piece-hudson/front/services/emplifi-hudson-transformer.service';

import { PieceHudsonRenderComponent } from './render/piece-hudson-render.component';


export const pieceHudsonRenderModuleEntryComponents = [
  PieceHudsonRenderComponent
];

@NgModule({
  imports: [
    RenderProductColorsModule,
    RenderProductPricesModule,
    RenderProductPurchaseOptionsModule,
    AltTextPipe,
    LazyLoadModule,
    RenderBlocksModule,
    RenderSharedModule,
    RenderVideoModule,
    SharedModule,
  ],
  providers: [
    ApiHudsonService,
    EmplifiHudsonTransformerService
  ],
  declarations: pieceHudsonRenderModuleEntryComponents
})
export class PieceHudsonRenderModule {}

export default pieceHudsonRenderModuleEntryComponents;
